export default __webpack_public_path__ + "assets/404.e0f3497dc2d45526053015592ab690fd.png";